module.exports = __webpack_public_path__ + "df0c054e7177c28a09d55092544bb50e.pdf";